interface Props {
  width?: number;
  height?: number;
  fill?: string;
}

export const CheckIcon = ({ width = 12, height = 10, fill = "#D82853" }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01914 9.5L0 5.27341L0.577398 4.66706L4.01914 8.28645L11.4234 0.5L12 1.1072L4.01914 9.5Z"
      fill={fill}
    />
  </svg>
);
